import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import type { TableColumn } from '@/types/table';
import type { AuditEvent } from '@/types/admin-settings';
import { useEventTypeLabel } from './useEventTypeLabel';
import { formatDate } from '@/utils/date';

export function useAuditEventColumns(): TableColumn<AuditEvent>[] {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const eventTypeLabel = useEventTypeLabel();
    return [
        {
            header: t('logs.timestamp'),
            cell: ({ row }) => (
                <span className="text-sm text-grey-300">
                    {row.original.createdAt
                        ? formatDate(new Date(row.original.createdAt))
                        : '-'}
                </span>
            ),
            width: '200px',
        },
        {
            header: t('logs.eventType'),
            cell: ({ row }) => (
                <span className="text-sm">
                    {eventTypeLabel(row.original.type)}
                </span>
            ),
            width: '220px',
        },
    ];
}
